import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {GuardConfig} from "../../guard/GuardConfig";
import {GuardMoney} from "../../guard/GuardMoney";
import {SmartOfferBundleKind} from "./SmartOfferBundleKind";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";

export class SmartOfferBundle extends BaseObject {

    constructor(kind = SmartOfferBundleKind.NONE) {
        super();

        this._key = "";
        this._name = "";
        this._kind = kind;

        this._iconBadgeExpires = 0;
        this._iconTooltipReset = 0;

        this._guard = new GuardConfig();
        this._guardMoney = new GuardMoney();
        this._rewardOnMerge = null;
        this._resetCurrency = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get guard() {
        return this._guard;
    }

    set guard(value) {
        this._guard = value;
    }

    get guardMoney() {
        return this._guardMoney;
    }

    set guardMoney(value) {
        this._guardMoney = value;
    }

    get rewardOnMerge() {
        return this._rewardOnMerge;
    }

    set rewardOnMerge(value) {
        this._rewardOnMerge = value;
    }

    get resetCurrency() {
        return this._resetCurrency;
    }

    set resetCurrency(value) {
        this._resetCurrency = value;
    }


    get iconBadgeExpires() {
        return this._iconBadgeExpires;
    }

    set iconBadgeExpires(value) {
        this._iconBadgeExpires = value;
    }

    get iconTooltipReset() {
        return this._iconTooltipReset;
    }

    set iconTooltipReset(value) {
        this._iconTooltipReset = value;
    }

    valid() {

        if (!SmartOfferBundleKind.is(this.kind) || SmartOfferBundleKind.isNone(this.kind)) {
            return false;
        }

        if (!Number.isInteger(this.iconBadgeExpires) || this.iconBadgeExpires < 0) {
            return false;
        }

        if (!Number.isInteger(this.iconTooltipReset) || this.iconTooltipReset < 0) {
            return false;
        }

        if (this.guard && !this.guard.valid()) {
            return false;
        }

        if (this.guardMoney && !this.guardMoney.valid()) {
            return false;
        }

        if (this.rewardOnMerge && !this.rewardOnMerge.empty() && !this.rewardOnMerge.valid()) {
            return false;
        }

        if (this.resetCurrency && this.resetCurrency.some(v => !v || !CurrencyKindModel.is(v))) {
            return false;
        }

        return true;
    }

    empty() {
        return SmartOfferBundleKind.isNone(this.kind);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundle());
        } else if (target instanceof SmartOfferBundle) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundle, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _kind: alias("kind", SmartOfferBundleKind.schema()),
    _guard: alias("guard", GuardConfig.schema()),
    _guardMoney: alias("guard_money", GuardMoney.schema()),
    _rewardOnMerge: alias("reward_merge", RewardModel.schema()),
    _resetCurrency: alias("reset_currency", list(CurrencyKindModel.schema())),
    _iconBadgeExpires: alias("icon_badge_expires", Schema.primitive()),
    _iconTooltipReset: alias("icon_tooltip_reset", Schema.primitive())
});
